export const toPascalCase = (str) => {
  if(!str) return str
  return str
    .toLowerCase()
    .replace(/(?:^|\s|_|-|\b)(\w)/g, (match, p1) => p1.toUpperCase())
    .replace(/[\s_-]/g, '');
};

export const capitalizeFirst = str => str.charAt(0).toUpperCase() + str.slice(1);
